export default __webpack_public_path__ + "static/media/cocina.eb822755.png";